import axios from 'axios';
import { currentRegisterToken, installRegisterRequestSafety } from './utils/registerSession';
const api = axios.create({ baseURL: process.env.REACT_APP_API_BASE_URL });
installRegisterRequestSafety(api);
api.interceptors.request.use(config => {
  // An explicitly captured token must never be replaced during a background job.
  if (!config.headers.Authorization && currentRegisterToken()) {
    config.headers.Authorization = `Bearer ${currentRegisterToken()}`;
  }
  return config;
});
export default api;
